/**
 * @file Slider Content
 */

import KeenSlider from 'keen-slider';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Slider Content component
 */
const vSliderContent = () => {
	const sliderContent = document.querySelectorAll( '.v-slider-content' );

	if ( ! sliderContent ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	/**
	 * Dumb modulo fix
	 *
	 * @param {number} n number to mod
	 * @return {number} result
	 */
	Number.prototype.mod = function( n ) {
		return ( ( this % n ) + n ) % n;
	};

	[ ...sliderContent ].forEach( ( el ) => {
		const keen        = el.querySelector( '.v-slider-content__keen' );
		const slides      = el.querySelectorAll( '.v-slider-content__image' );
		const arrowPrev   = el.querySelector( '.v-slider-content__button--prev' );
		const arrowNext   = el.querySelector( '.v-slider-content__button--next' );
		const inner       = el.querySelectorAll( '.v-slider-content__flex' );
		const gsapFrom    = { opacity: 0 };
		const tweenVars   = {
			opacity:  1,
			duration: 1,
			ease:     'power1.inOut',
		};
		const triggerVars = {
			trigger:       el,
			toggleActions: 'play none none reset',
		};

		gsap.fromTo( inner, gsapFrom, {
			scrollTrigger: {
				start: 'top bottom-=10%',
				...triggerVars,
			},
			...tweenVars,
		} );

		new KeenSlider( keen, {
			loop:    true,
			mounted: () => {
				ScrollTrigger.refresh();
			},
			created: ( instance ) => {
				// Transition

				arrowPrev.addEventListener( 'click', ( e ) => {
					e.preventDefault();
					arrowPrev.classList.add( 'v-slider-content__button--transition' );
					arrowNext.classList.add( 'v-slider-content__button--transition' );
					setTimeout( () => instance.prev(), 150 );
				} );

				arrowNext.addEventListener( 'click', ( e ) => {
					e.preventDefault();
					arrowPrev.classList.add( 'v-slider-content__button--transition' );
					arrowNext.classList.add( 'v-slider-content__button--transition' );
					setTimeout( () => instance.next(), 150 );
				} );

				ScrollTrigger.refresh();
			},
			move: ( instance ) => {
				const slideNum = instance.details().relativeSlide;
				const nextImg  = slides[ ( slideNum + 1 ).mod( slides.length ) ];
				const prevImg  = slides[ ( slideNum - 1 ).mod( slides.length ) ];

				// Set new background
				arrowNext.setAttribute( 'style', `background-image: url("${ nextImg.src }")` );
				arrowPrev.setAttribute( 'style', `background-image: url("${ prevImg.src }")` );

				// Reveal
				setTimeout( () => {
					arrowNext.classList.remove( 'v-slider-content__button--transition' );
					arrowPrev.classList.remove( 'v-slider-content__button--transition' );
				}, 500 );
			},
		} );
	} );
};

export default vSliderContent;
